var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "top10list" },
    [
      _c("div", { staticClass: "title" }, [
        _c("h3", [
          _vm._v(
            _vm._s(
              _vm.mode
                ? _vm.$t("dashboard.top10SmsCount")
                : _vm.$t("dashboard.top10Agent")
            )
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "description" }, [
          _vm._v(_vm._s(_vm.data[0] ? _vm.data[0].date : ""))
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-table",
        {
          staticClass: "list",
          staticStyle: { width: "100%", "border-color": "rgba(0,0,0,0.45)" },
          attrs: {
            data: _vm.data,
            gutter: 0,
            "cell-style": "background-color: transparent; padding: 20px;",
            "row-style": "background-color: transparent",
            "header-cell-style":
              "background-color: transparent; color: rgba(0, 0, 0, 0.45);s",
            "header-row-style": "background-color: transparent;"
          }
        },
        [
          _c("el-table-column", {
            attrs: { prop: "label", label: "", width: "75%" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "value", label: this.label, width: "25%" }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }